import { createSlice } from "@reduxjs/toolkit";
import VwHbsIslembolumtanimDTO from "src/models/GenelTanimlar/hbsislembolumtanimDTO";
import VwHbsIslemtanimDTO from "src/models/GenelTanimlar/VwHbsIslemtanimDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { IslemApi } from "src/services/Islem/IslemApi";

interface IEgitimState {
  secilenIslemBolum: VwHbsIslembolumtanimDTO;
  open: boolean;
}

const EgitimSlice = createSlice<IEgitimState, MapReducerPayloads<IEgitimState, {
  setState: IEgitimState,
  setSecilenIslemBolum: VwHbsIslembolumtanimDTO,
  setOpen: boolean
}>>({
  name: 'Egitim',
  initialState: {
    secilenIslemBolum: new VwHbsIslembolumtanimDTO(),
    open: false
  },
  reducers: {
    setState: (state, action) => action.payload,
    setSecilenIslemBolum: (state, action) => {
      state.secilenIslemBolum = action.payload
    },
    setOpen: (state, action)  => {
      state.open = action.payload
    }
  },

})

export default EgitimSlice;